<template>
  <transition name="sideUp">
    <div v-show="showTips">
      <div class="tips-mask"  @touchmove.prevent></div>
      <div class="tips">
        <div class="tips-content">
          <p class="tips-title">{{tipTitle}}</p>
          <button class="tips-ok" @click.stop="clickOkBtn()">{{okBtnText}}</button>
          <button class="tips-cancle" @click.stop="hideTips()">取消</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import store from 'store'
  export default {
    props: {
      tipsType: {
        type: String,
        default: 'confirmDelete'
      },
      tipTitle: {
        type: String,
        default: ''
      },
      okBtnText: {
        type: String,
        default: '确定'
      },
      clickCallBack: {
        type: Function,
        default: undefined
      }
    },
    data () {
      return {
      }
    },
    methods: {
      clickOkBtn () {
        this.clickCallBack()
        this.hideTips()
      },
      hideTips () {
        store.commit('hideConfirmTips')
      }

    },
    computed: {
      showTips () {
        return this.$store.getters.getTipsIsShow === this.tipsType
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// tips.vue?02b8c5ea